//removeIf(production)
import ClaroluzOffer from "../../../../../domain/entities/claroluz-offer";
//endRemoveIf(production)

class ClaroluzDetail {
    private cups: string;
    private id: number;
    private offer: ClaroluzOffer;

    constructor(cups: string, id: number, offer: ClaroluzOffer) {
        this.cups = cups;
        this.id = id;
        this.offer = offer;

        this.detail();
    }

    public detail() {
        let offer = this.offer;
        let days = offer.power1.intervalDays;

        let currentValue = document.querySelector('.card-item-' + this.id + ' .claroluz-current-value')!.innerHTML;
        let percentage = document.querySelector('.card-item-' + this.id + ' .claroluz-card-band')!.innerHTML;
        let imageSrc = document.querySelector('.card-item-' + this.id + ' .claroluz-card-preview img')?.getAttribute('src');
        let product = document.querySelector('.card-item-' + this.id + ' .long-desc')!.innerHTML;
        
        document.querySelector('.claroluz-card-detail .claroluz-card-preview img')!.setAttribute('src', imageSrc!);
        document.querySelector('.claroluz-card-detail .claroluz-card-band')!.innerHTML = percentage;
        document.querySelector('.claroluz-card-detail .claroluz-current-value')!.innerHTML = currentValue;
        document.querySelector('.claroluz-card-detail .short-desc')!.innerHTML = product;


        document.querySelector('.card-price-power')!.innerHTML = ClaroluzValueFormat.of(offer.powerTotal.value) + '€';

        let powerP1 = offer.power1.value;
        let priceP1 = offer.power1.price;
        document.querySelector('.card-detail-power1')!.innerHTML = ClaroluzValueFormat.of(powerP1) + 'kW x ' + days + ' días x ' + this.format(priceP1) + ' €/kW día';

        let powerP2 = offer.power2.value;
        let priceP2 = offer.power2.price;
        document.querySelector('.card-detail-power2')!.innerHTML = ClaroluzValueFormat.of(powerP2) + 'kW x ' + days + ' días x ' + this.format(priceP2) + ' €/kW día';


        document.querySelector('.card-price-energy')!.innerHTML = ClaroluzValueFormat.of(offer.energyTotal) + '€';
        document.querySelector('.card-detail-energy1')!.innerHTML = ClaroluzValueFormat.of(offer.energy1.value) + 'kWh x ' + ClaroluzValueFormat.of(offer.energy1.price) + ' €/kWh';

        if (offer.energy2 != null) {
            document.querySelector('.card-detail-energy2')!.innerHTML = ClaroluzValueFormat.of(offer.energy2.value) + 'kWh x ' + ClaroluzValueFormat.of(offer.energy2.price) + ' €/kWh';
            document.querySelector('.card-detail-content-energy2')!.classList.remove('display-none');
        } else {
            document.querySelector('.card-detail-content-energy2')!.classList.add('display-none');
        }

        if (offer.energy3 != null) {
            document.querySelector('.card-detail-energy3')!.innerHTML = ClaroluzValueFormat.of(offer.energy3.value) + 'kWh x ' + ClaroluzValueFormat.of(offer.energy3.price) + ' €/kWh';
            document.querySelector('.card-detail-content-energy3')!.classList.remove('display-none');
        } else {
            document.querySelector('.card-detail-content-energy3')!.classList.add('display-none');
        }

        document.querySelector('.card-price-tax')!.innerHTML = ClaroluzValueFormat.of(offer.totalVatValue) + '€';
        document.querySelector('.card-detail-tax1')!.innerHTML = ClaroluzValueFormat.of(offer.electricalTax) + '€';
        document.querySelector('.card-detail-tax2')!.innerHTML = ClaroluzValueFormat.of(offer.roundedVatValue) + '€';
        document.querySelector('.card-detail-tax3')!.innerHTML = ClaroluzValueFormat.of(offer.measureDeviceRenting) + '€';
        document.querySelector('.claroluz-detail-container .claroluz-card-button-contract')!.setAttribute('data-id', this.id.toString());

        if (document.querySelector('.claroluz-card-current .topgas')!.getAttribute('data-topgas') === 'offer') {
            document.querySelector('.card-detail-energy4')!.innerHTML = document.querySelector('.claroluz-card-current .topgas-offer')!.innerHTML;
            document.querySelector('.card-detail-content-energy4')!.classList.remove('display-none');
        } else {
            document.querySelector('.card-detail-content-energy4')!.classList.add('display-none');
        }

    }

    private format(number: number) {
        let value = number.toString();
        value = value.replace(/\./g, ",");
        return value;
    }
}

//removeIf(production)
export default ClaroluzDetail;
//endRemoveIf(production)